import { FdrProductType } from '@hotelplan/supergraph-api';
import { fdrBlogCriteria } from 'components/util/criterias/blog.dmc';
import { fdrHeroCriteria } from 'components/util/criterias/hero.dmc';
import { fdrMarketingRecommendation } from 'components/util/criterias/marketingRecommendation.dmc';
import {
  fdrMediaFull,
  fdrMediaPreview,
} from 'components/util/criterias/media.dmc';

export const DEFAULT_GEO_PRODUCT_PAGINATION_PER_PAGE = 9;

export const fdrGeoPageModulesVars = {
  blogCriteria: fdrBlogCriteria,
  childrenInput: {
    pagination: { page: 0, perPage: 100 },
  },
  productsInput: {
    pagination: { page: 0, perPage: DEFAULT_GEO_PRODUCT_PAGINATION_PER_PAGE },
    productTypes: [FdrProductType.AdventureTravel],
  },
  hotelsInput: {
    pagination: { page: 0, perPage: 1000 },
    productTypes: [FdrProductType.Hotel],
  },
  blogArticleInput: {
    pagination: { page: 0, perPage: DEFAULT_GEO_PRODUCT_PAGINATION_PER_PAGE },
  },
  themeGeoInput: {
    pagination: { page: 0, perPage: 12 },
  },
};

export const SIBLINGS_DEFAULT_RESULT_PER_PAGE = 3;

export const fdrGeoPageComponentsVars = {
  blogCriteria: fdrBlogCriteria,
  pageComponentsInput: { pagination: { page: 0, perPage: 100 } },
  heroCriteria: fdrHeroCriteria,
  mediaFull: fdrMediaFull,
  mediaPreview: fdrMediaPreview,
  fdrMarketing: fdrMarketingRecommendation,
};

export const fdrGeoPageSiblingsDesktopVars = {
  siblingsInput: {
    pagination: {
      page: 0,
      perPage: SIBLINGS_DEFAULT_RESULT_PER_PAGE,
    },
  },
};

export const fdrGeoPageSiblingsMobileVars = {
  siblingsInput: {
    pagination: {
      page: 0,
      perPage: 100,
    },
  },
};

export const GEO_MAP_PRODUCT_LIMIT = 1000;

export const fdrGeoMapProductVars = {
  productLimit: GEO_MAP_PRODUCT_LIMIT,
  imageCriteria: fdrHeroCriteria,
};
